import { DEFAULT_ID, Loader } from '@googlemaps/js-api-loader';
import axios from 'axios';

export function init(apiBase, apiKey) {
	if (document.querySelector('.module-eventinfo')) {

		let errorRedirect = '../events';

		const selectText = document.querySelector('.module-eventinfo').getAttribute('data-selecttext');

		document.querySelector('.overlay').classList.add('-white');
		document.querySelector('.overlay').classList.add('-visible');

		// Set up Map ----------------------- //
		let map;

		const loader = new Loader({
			apiKey: apiKey,
			version: 'weekly'
		});

		loader.load().then(() => {

			const userlat = parseFloat(document.querySelector('.geo-information .latitude').innerText);
			const userlng = parseFloat(document.querySelector('.geo-information .longitude').innerText);

			map = new google.maps.Map(document.getElementById('single-event-map'), {
				center: { lat: userlat, lng: userlng },
				zoom: 12,
			});

		});
		// End Set up Map ---------------------- //

		// Get event data from API and populate DOM ------------ //
		const urlPath = window.location.pathname.split('/');

		let eventId = urlPath[urlPath.length - 1];
		if(!eventId){
			eventId = urlPath[urlPath.length - 2];
		}

		let bookingId = '';

		if (urlPath.includes('cancel')) {
			eventId = urlPath[urlPath.length - 3];
			bookingId = urlPath[urlPath.length - 1];

			document.querySelector('.cancel-booking input[name="bookingId"]').value = bookingId;
		}

		axios({
			method: 'get',
			url: apiBase + 'events/' + eventId
		})
			.then(function (response) {
				if (response.data === '') { // no match
					window.location = errorRedirect;
				} else {

					// console.log(response.data);

					// get timezone
					let timeZone = "UTC";
					response.data.links.forEach((el) => {
						if (el.rel === "timezone") {
							let timeZoneArr = el.href.split('/');
							timeZone = decodeURIComponent(timeZoneArr[timeZoneArr.length - 1]);
						}
					});

					document.querySelector('.overlay').classList.remove('-visible');
					document.querySelector('.overlay').classList.remove('-white');

					if (response.data.geocode) {

						const latlong = { lat: parseFloat(response.data.geocode.latitude), lng: parseFloat(response.data.geocode.longitude) };

						setTimeout(() => {
							const marker = new google.maps.Marker({
								position: latlong,
								map: map,
								icon: 'https://' + window.location.hostname + '/assets/dist/img/icon-map-pin.svg'
							});
							map.setCenter(latlong);
						}, 500);

					} else {
						document.querySelector('#single-event-map').classList.add('-hidden');
						document.querySelector('.right .details').classList.add('-hidden');
					}

					document.title = response.data.name + ' | ' + document.title;
					document.querySelector('.module-pageheader h1').innerText = response.data.name;

					let locationString = '';
					if (response.data.type === 'Online Event') {
						locationString = 'Online';
					} else {
						const addressArray = [];
						if (response.data.venueName) { addressArray.push(response.data.venueName) }
						if (response.data.address.city) { addressArray.push(response.data.address.city) }
						if (response.data.address.country) { addressArray.push(response.data.address.country) }

						addressArray.forEach(function (line, i) {
							let output = '';
							if (i > 0) {
								output += ', ';
							}
							output += line;
							locationString += output;
						});
					}

					let dateString = new Date(response.data.dateTime).toDateString();

					document.querySelector('.module-pageheader h3').innerText = locationString + ' | ' + dateString;

					document.querySelector('input.event-id').value = response.data.id;

					// Image
					response.data.links.forEach(function (link) {
						if (link.rel === 'large-image') {
							document.querySelector('.event-image').innerHTML = `<img src="${link.href}">`;
						}
					});

					// Address
					const addressArray = [];
					if (response.data.venueName) { addressArray.push(response.data.venueName) }
					if (response.data.address.line1) { addressArray.push(response.data.address.line1) }
					if (response.data.address.line2) { addressArray.push(response.data.address.line2) }
					if (response.data.address.line3) { addressArray.push(response.data.address.line3) }
					if (response.data.address.city) { addressArray.push(response.data.address.city) }
					if (response.data.address.postcode) { addressArray.push(response.data.address.postcode) }
					if (response.data.address.country) { addressArray.push(response.data.address.country) }

					addressArray.forEach(function (line, i) {
						let output = '';
						if (i > 0) {
							output += '<br>';
						}
						output += line;
						document.querySelector('.module-eventinfo .address .content').innerHTML += output;
					});

					let descriptionHTML = '';
					if (response.data.summary) { descriptionHTML += `<p><em>${response.data.summary}</em></p>` }
					if (response.data.details) 
					{ 
						let paragraphs = response.data.details.split("\n");
						paragraphs.forEach(x => descriptionHTML += `<p>${x}</p>` );
					}
					document.querySelector('.module-eventinfo .description').innerHTML = descriptionHTML;

					// Booking forms
					let slotsAvailable = false;

					let timeOptionsHtml = `<option value="">${selectText}</option>`;
					let timeOptionsHtmlWaitList = timeOptionsHtml;

					if (response.data.timeslots.length === 0) {

						let timeString = new Date(response.data.dateTime).toLocaleTimeString('en-GB', { timeZone: timeZone });
						let buildTimeString = timeString.substring(0, timeString.length - 3);

						if(response.data.numberOfBookings < response.data.capacity){
							slotsAvailable = true;
						}

						timeOptionsHtml = `<option value="na">${buildTimeString} (${timeZone})</option>`;
						timeOptionsHtmlWaitList = timeOptionsHtml;

					} else {

						response.data.timeslots.forEach(function (timeslot) {

							if (timeslot.fullyBooked === false) {
								slotsAvailable = true;
								timeOptionsHtml += `<option value="${timeslot.id}">${timeslot.startTime} - ${timeslot.endTime} (${timeZone})</option>`;
							} else {
								timeOptionsHtml += `<option value="" disabled>${timeslot.startTime} - ${timeslot.endTime} (${timeZone})</option>`;
							}
							timeOptionsHtmlWaitList += `<option value="${timeslot.id}">${timeslot.startTime} - ${timeslot.endTime} (${timeZone})</option>`;
						});
					}

					if((response.data.capacity - response.data.numberOfBookings) === 1){
						document.getElementById('second-ticket').disabled = true;
					}

					if (slotsAvailable) {
						// show booking form
						document.querySelector('.module-eventinfo .booking-form.-available').classList.remove('-hidden');
					} else {
						// show waiting list form
						document.querySelector('.module-eventinfo .booking-form.-waitlist').classList.remove('-hidden');
					}

					if (document.querySelector('.event-booking')) {
						document.querySelector('.event-booking select#time').innerHTML = timeOptionsHtml;
					}

					if (document.querySelector('.waitlist-booking')) {
						document.querySelector('.waitlist-booking select#time').innerHTML = timeOptionsHtmlWaitList;
					}

				}
			})
			.catch(function (error) {
				console.log(error);
				// window.location = errorRedirect;
			});

		// End get event data from API ---------------- //

		// Handle form submissions -------------------- //

		if (document.querySelector('.event-booking')) {
			document.querySelector('.event-booking').addEventListener('submit', function (e) {
				e.preventDefault();

			if (document.querySelector('.event-booking .g-recaptcha-response').value !== "") {

				document.querySelector('.recaptcha-validation-text').style.visibility = "hidden";

				document.querySelector('.overlay').classList.add('-white');
				document.querySelector('.overlay').classList.add('-visible');

				const formData = new FormData();

				formData.append('name', document.querySelector('.event-booking input[name="name"]').value);
				formData.append('email', document.querySelector('.event-booking input[name="emailAddress"]').value);
				formData.append('postcode', document.querySelector('.event-booking input[name="postCode"]').value);
				formData.append('country', document.querySelector('.event-booking select[name="country"]').value);
				formData.append("aboutMe", document.querySelector('.event-booking select[name="about"]').value);

				formData.append('subscribe', !document.querySelector('.event-booking input[name="emailSubscribe"]').checked);
				if (document.querySelector('.event-booking select[name="time"]').value !== 'na') {
					formData.append('timeslotId', document.querySelector('.event-booking select[name="time"]').value);
				}
				formData.append('numberAttending', document.querySelector('.event-booking select[name="quantity"]').value);
				formData.append(
					"g-recaptcha-response",
					document.querySelector('.event-booking .g-recaptcha-response').value
				)

				axios({
					method: 'post',
					url: apiBase + 'events/' + document.querySelector('input.event-id').value + '/bookings',
					data: formData,
					headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
				})
					.then(function (response) {
						//success
						document.querySelector('.overlay').classList.remove('-white');
						document.querySelector('.overlay').classList.remove('-visible');
						document.querySelector('.event-booking').remove();
						document.querySelector('.booking-form.-available .thanks').classList.remove('-hidden');
						document.querySelector('.booking-form.-available').scrollIntoView();
					})
					.catch(function (error) {
						document.querySelector('.overlay').classList.remove('-white');
						document.querySelector('.overlay').classList.remove('-visible');
						document.querySelector('.event-booking').remove();
						document.querySelector('.booking-form.-available .error').classList.remove('-hidden');
						document.querySelector('.booking-form.-available .error p').innerText = error.response.data.errorMessage;
						document.querySelector('.booking-form.-available').scrollIntoView();
					});

				}
				else {
					document.querySelector('.recaptcha-validation-text').style.visibility = "visible";
				}
			});
		}

		if (document.querySelector('.waitlist-booking')) {
			document.querySelector('.waitlist-booking').addEventListener('submit', function (e) {
				e.preventDefault();

				if (document.querySelector('.waitlist-booking .g-recaptcha-response').value !== "") {

				document.querySelector('.recaptcha-validation-text').style.visibility = "hidden";


				document.querySelector('.overlay').classList.add('-white');
				document.querySelector('.overlay').classList.add('-visible');

				const formData = new FormData();

				formData.append('name', document.querySelector('.waitlist-booking input[name="name"]').value);
				formData.append('email', document.querySelector('.waitlist-booking input[name="emailAddress"]').value);
				formData.append('postcode', document.querySelector('.waitlist-booking input[name="postCode"]').value);
				formData.append('country', document.querySelector('.waitlist-booking select[name="country"]').value);
				formData.append('subscribe', !document.querySelector('.waitlist-booking input[name="emailSubscribe"]').checked);
				formData.append('timeslotId', document.querySelector('.waitlist-booking select[name="time"]').value);
				formData.append('numberAttending', document.querySelector('.waitlist-booking select[name="quantity"]').value);

				formData.append(
					"g-recaptcha-response",
					document.querySelector('.waitlist-booking .g-recaptcha-response').value
				)

				axios({
					method: 'post',
					url: apiBase + 'events/' + document.querySelector('input.event-id').value + '/waitinglist',
					data: formData,
					headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
				})
					.then(function (response) {
						//success
						document.querySelector('.overlay').classList.remove('-white');
						document.querySelector('.overlay').classList.remove('-visible');
						document.querySelector('.waitlist-booking').remove();
						document.querySelector('.booking-form.-waitlist .thanks').classList.remove('-hidden');
						document.querySelector('.booking-form.-waitlist').scrollIntoView();
					})
					.catch(function (error) {
						document.querySelector('.overlay').classList.remove('-white');
						document.querySelector('.overlay').classList.remove('-visible');
						document.querySelector('.waitlist-booking').remove();
						document.querySelector('.booking-form.-waitlist .error').classList.remove('-hidden');
						document.querySelector('.booking-form.-waitlist .error').innerText = error.response.data.errorMessage;
						document.querySelector('.booking-form.-waitlist').scrollIntoView();
					});

				}
				else {
					document.querySelector('.recaptcha-validation-text').style.visibility = "visible";
				}
			});
		}

		if (document.querySelector('.cancel-booking')) {
			document.querySelector('.cancel-booking').addEventListener('submit', function (e) {
				e.preventDefault();

				if (document.querySelector('.cancel-booking .g-recaptcha-response').value !== "") {

				document.querySelector('.overlay').classList.add('-white');
				document.querySelector('.overlay').classList.add('-visible');

				const formData = new FormData();
				formData.append('eventId', document.querySelector('.cancel-booking input[name="eventId"]').value);
				formData.append('bookingId', document.querySelector('.cancel-booking input[name="bookingId"]').value);
				formData.append('cancelReason', document.querySelector('.cancel-booking input[name="reason"]').value);

				formData.append(
					"g-recaptcha-response",
					document.querySelector('.cancel-booking .g-recaptcha-response').value
				)

				axios({
					method: 'post',
					url: apiBase + 'events/cancel',
					data: formData,
					headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
				})
					.then(function (response) {
						//success
						document.querySelector('.overlay').classList.remove('-white');
						document.querySelector('.overlay').classList.remove('-visible');
						document.querySelector('.cancel-booking').remove();
						document.querySelector('.booking-form.-available .thanks').classList.remove('-hidden');
						document.querySelector('.booking-form.-available').scrollIntoView();
					})
					.catch(function (error) {
						document.querySelector('.overlay').classList.remove('-white');
						document.querySelector('.overlay').classList.remove('-visible');
						document.querySelector('.booking-form.-available .error').classList.remove('-hidden');
						document.querySelector('.booking-form.-available .error').innerText = 'Sorry, it looks like something went wrong.';
						document.querySelector('.booking-form.-available').scrollIntoView();
					});
				}
			});
		}

	}
}